import { Datum, Serie } from '@nivo/line'

export type EnergyAnalysisResultDate = {
    Date: string
    UserCount: UserSplitCount
    SubmitCount: UserSplitCount
    UploadCount: UserSplitCount
}

type UserSplitCount = {
    Total: string
    GroupSplit: [UserGroup]
    UserGroupSplit: [UserGroup]
}

type UserGroup = {
    Name: string
    Count: string
}

export const formatDateForEnergyGraph = (dateStr: string): Date => {
    return new Date(dateStr)
}

export const formatLineGraphTotalsAsPercentage = (
    data: EnergyAnalysisResultDate[],
    field: string,
    view: string,
): Serie[] => {
    if (view == 'total') {
        const percentage: Datum[] = []
        data.forEach((d) => {
            percentage.push({
                x: formatDateForEnergyGraph(d.Date),
                y: (Number(d[field].Total) / Number(d.UserCount.Total)) * 100,
            })
        })
        return [
            {
                id: field + 'Percentage',
                data: percentage,
            },
        ]
    } else if (view == 'usergroup') {
        const results: Serie[] = []
        data.forEach((d) => {
            ;(d[field].UserGroupSplit as [UserGroup]).forEach((ug) => {
                const seriesForThisGroup = results.filter((a) => a.id == ug.Name)
                if (seriesForThisGroup.length) {
                    seriesForThisGroup[0].data.push({
                        x: formatDateForEnergyGraph(d.Date),
                        y: (Number(ug.Count) / Number(getUserCountForUserGroup(d, ug.Name))) * 100,
                    })
                } else {
                    results.push({
                        data: [
                            {
                                x: formatDateForEnergyGraph(d.Date),
                                y:
                                    (Number(ug.Count) /
                                        Number(getUserCountForUserGroup(d, ug.Name))) *
                                    100,
                            },
                        ],
                        id: ug.Name,
                    })
                }
            })
        })
        return results
    } else {
        const results: Serie[] = []
        data.forEach((d) => {
            ;(d[field].GroupSplit as [UserGroup]).forEach((group) => {
                const seriesForThisGroup = results.filter((a) => a.id == group.Name)
                if (seriesForThisGroup.length) {
                    seriesForThisGroup[0].data.push({
                        x: formatDateForEnergyGraph(d.Date),
                        y:
                            (Number(group.Count) / Number(getUserCountForGroup(d, group.Name))) *
                            100,
                    })
                } else {
                    results.push({
                        data: [
                            {
                                x: formatDateForEnergyGraph(d.Date),
                                y:
                                    (Number(group.Count) /
                                        Number(getUserCountForGroup(d, group.Name))) *
                                    100,
                            },
                        ],
                        id: group.Name,
                    })
                }
            })
        })
        return results
    }
}

const getUserCountForGroup = (dateResult: EnergyAnalysisResultDate, group: string): number => {
    const r = dateResult.UserCount.GroupSplit.filter((s) => s.Name == group)
    if (!r.length) throw new Error('Group not found')
    return Number(r[0].Count)
}

const getUserCountForUserGroup = (dateResult: EnergyAnalysisResultDate, group: string): number => {
    const r = dateResult.UserCount.UserGroupSplit.filter((s) => s.Name == group)
    if (!r.length) throw new Error('User group not found')
    return Number(r[0].Count)
}
